<div class="modal-header">
  <div class="icon-container"></div>
  <h2 class="title">{{title}}</h2>
</div>

 <!-- Description -->
 <p class="description">{{description}}</p>

<!-- Form -->
<form #profileForm="ngForm" *ngIf="!isProfileCompleted">
  <div class="form-row">
    <!-- First Name -->
    <div class="form-group">
      <app-input
        [type]="'text'"
        name="firstName"
        [(ngModel)]="formData.firstName"
        [formGroup]="profileForm"
        label="First Name*"
        placeholder="First Name"
        required
        pattern="^([a-zA-Z]+(-[a-zA-Z]+)*(\s|$))+$"
      ></app-input>
    </div>

    <!-- Last Name -->
    <div class="form-group">
      <app-input
        [type]="'text'"
        name="lastName"
        [(ngModel)]="formData.lastName"
        [formGroup]="profileForm"
        label="Last Name*"
        placeholder="Last Name"
        required
        pattern="^([a-zA-Z]+(-[a-zA-Z]+)*(\s|$))+$"
      ></app-input>
    </div>
  </div>

  <div class="form-row">
    <!-- Age Range -->
    <div class="form-group">
      <app-input
        [type]="'dropdown'"
        name="ageRange"
        [(ngModel)]="formData.ageRange"
        [formGroup]="profileForm"
        label="Age Range*"
        placeholder="Select"
        [options]="ageRanges"
        [defaultOption]="'Select'"
        required
      ></app-input>
    </div>

    <!-- Gender -->
    <div class="form-group">
      <app-input
        [type]="'dropdown'"
        name="gender"
        [(ngModel)]="formData.gender"
        [formGroup]="profileForm"
        label="Gender*"
        placeholder="Select"
        [options]="genders"
        [defaultOption]="'Select'"
        required
      ></app-input>
    </div>
  </div>

  <div class="form-row">
    <!-- Country -->
    <div class="form-group">
      <app-input
        [type]="'dropdown'"
        name="country"
        [(ngModel)]="formData.country"
        [formGroup]="profileForm"
        label="Country*"
        placeholder="United States"
        [options]="countries"
        [defaultOption]="'Select'"
        required
      ></app-input>
    </div>

    <!-- Zip Code -->
    <div class="form-group">
      <app-input
        [type]="'text'"
        name="zipCode"
        [(ngModel)]="formData.zipCode"
        [formGroup]="profileForm"
        label="Zip code*"
        placeholder="Zip code"
        pattern="^\d{5}$"
        required
      ></app-input>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group">
      <app-input [type]="'text'" name="phone" [formGroup]="profileForm" (input)="formatPhoneNumber($event)"
          label="Phone number *" [placeholder]="'Phone number'" [(ngModel)]="formData.phoneNumber"
          pattern="^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$" required>
        </app-input>
    </div>
    <div class="form-group"></div>
  </div>
  <div class="form-row">
    <app-marketing-info  [userProfile]="userProfile" [elementName]="'sms'" (userProfileChange)="smsOptInChange($event)"></app-marketing-info>
  </div>
</form>

<div class="footer">
  <button *ngIf="isSkipable" class="modal-button cancel-button" (click)="onSkip()">Skip</button>

  <button *ngIf="isProfileCompleted;else profileCompletedButton" class="modal-button confirm-btn" (click)="onSubmit()">
    <b>Continue</b>
  </button>

  <ng-template #profileCompletedButton>
    <button [disabled]="!isFormValid" class="modal-button confirm-btn" (click)="onSubmit()">
      <b>Continue</b>
    </button>
  </ng-template>
</div>
